export default "__VITE_ASSET__BSZSn_kh__"